import React from 'react'
import { Helmet } from 'react-helmet'

export const CustomHeadElements = props => {
  return <Helmet></Helmet>
}
